import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-875e3330"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container mt-4" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-md-12 d-flex flex-column gap-4" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "text-center mb-4" }, " Claims History Search ", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-body" }, " Select parameters below to search for a specific claim or all claims for a specific date range. ")
], -1))
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  key: 1,
  class: "d-flex flex-column gap-4"
}
const _hoisted_8 = { class: "d-flex align-items-center gap-4 w-100" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "col-md-2" }, " Enter Claim # ", -1))
const _hoisted_10 = { class: "d-flex align-items-center gap-4 w-100" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "col-md-2" }, "Enter Web Reference # ", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "If you do not have a Claim # use filters below to search for Claim", -1))
const _hoisted_13 = { class: "d-flex align-items-center gap-4 w-100" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "col-md-2" }, " Patient Name: ", -1))
const _hoisted_15 = { class: "w-50" }
const _hoisted_16 = { class: "d-flex align-items-center gap-4 w-100" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "col-md-2" }, " Service Date(s): ", -1))
const _hoisted_18 = { class: "w-50 d-flex align-items-center gap-4" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "-", -1))
const _hoisted_20 = { class: "d-flex align-items-center gap-4 w-100" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "col-md-2" }, " Submission Date(s): ", -1))
const _hoisted_22 = { class: "w-50 d-flex align-items-center gap-4" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "-", -1))
const _hoisted_24 = { class: "d-flex align-items-center gap-4 w-100" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "col-md-2" }, " Claim Status: ", -1))
const _hoisted_26 = { class: "w-50" }
const _hoisted_27 = { class: "d-flex gap-2 justify-content-between w-100" }
const _hoisted_28 = { key: 2 }
const _hoisted_29 = { class: "table table-bordered table-striped" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", { class: "table-dark" }, [
  /*#__PURE__*/_createElementVNode("tr", { class: "text-center align-middle" }, [
    /*#__PURE__*/_createElementVNode("th", { colspan: "2" }, "Claim #"),
    /*#__PURE__*/_createElementVNode("th", null, "Web Ref #"),
    /*#__PURE__*/_createElementVNode("th", null, [
      /*#__PURE__*/_createTextVNode("Date(s) of "),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode("Service")
    ]),
    /*#__PURE__*/_createElementVNode("th", { colspan: "3" }, "Patient Information"),
    /*#__PURE__*/_createElementVNode("th", null, "Claim Status "),
    /*#__PURE__*/_createElementVNode("th", null, "Claim Document(s)"),
    /*#__PURE__*/_createElementVNode("th", null, "EoB Document")
  ]),
  /*#__PURE__*/_createElementVNode("tr", { class: "text-center align-middle" }, [
    /*#__PURE__*/_createElementVNode("th"),
    /*#__PURE__*/_createElementVNode("th"),
    /*#__PURE__*/_createElementVNode("th"),
    /*#__PURE__*/_createElementVNode("th"),
    /*#__PURE__*/_createElementVNode("th", null, "Name"),
    /*#__PURE__*/_createElementVNode("th", null, "DOB"),
    /*#__PURE__*/_createElementVNode("th", null, "Relationship"),
    /*#__PURE__*/_createElementVNode("th"),
    /*#__PURE__*/_createElementVNode("th"),
    /*#__PURE__*/_createElementVNode("th")
  ])
], -1))
const _hoisted_31 = { class: "text-center" }
const _hoisted_32 = ["onClick"]
const _hoisted_33 = { key: 0 }
const _hoisted_34 = { key: 1 }
const _hoisted_35 = { key: 2 }
const _hoisted_36 = { key: 3 }
const _hoisted_37 = { colspan: "10" }
const _hoisted_38 = { class: "table table-striped" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", { class: "table-light" }, [
  /*#__PURE__*/_createElementVNode("tr", { class: "text-center align-middle" }, [
    /*#__PURE__*/_createElementVNode("th", null, [
      /*#__PURE__*/_createElementVNode("b", null, "Amt Requested")
    ]),
    /*#__PURE__*/_createElementVNode("th", null, [
      /*#__PURE__*/_createElementVNode("b", null, "Pd By Other Carrier")
    ]),
    /*#__PURE__*/_createElementVNode("th", null, [
      /*#__PURE__*/_createElementVNode("b", null, "Admin Fee")
    ]),
    /*#__PURE__*/_createElementVNode("th", null, [
      /*#__PURE__*/_createElementVNode("b", null, "Amt Paid")
    ]),
    /*#__PURE__*/_createElementVNode("th", null, [
      /*#__PURE__*/_createElementVNode("b", null, "Reqst Date")
    ]),
    /*#__PURE__*/_createElementVNode("th", null, [
      /*#__PURE__*/_createElementVNode("b", null, "Payment Info")
    ]),
    /*#__PURE__*/_createElementVNode("th", null, [
      /*#__PURE__*/_createElementVNode("b", null, "Check / Deposit Date")
    ]),
    /*#__PURE__*/_createElementVNode("th", null, [
      /*#__PURE__*/_createElementVNode("b", null, "Previous Claim #")
    ]),
    /*#__PURE__*/_createElementVNode("th", null, [
      /*#__PURE__*/_createElementVNode("b", null, "Notes")
    ])
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AlertsComponent = _resolveComponent("AlertsComponent")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_AlertsComponent, {
      success: $setup.success,
      errors: $setup.errors
    }, null, 8, ["success", "errors"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _hoisted_5,
        ($setup.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, " Loading... "))
          : (!$setup.loading && $setup.claimsHistory?.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _hoisted_9,
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.filters.Claim) = $event)),
                    class: "form-control w-50"
                  }, null, 512), [
                    [_vModelText, $setup.filters.Claim]
                  ])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _hoisted_11,
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.filters.WebReference) = $event)),
                    class: "form-control w-50"
                  }, null, 512), [
                    [_vModelText, $setup.filters.WebReference]
                  ])
                ]),
                _hoisted_12,
                _createElementVNode("div", _hoisted_13, [
                  _hoisted_14,
                  _createElementVNode("div", _hoisted_15, [
                    _createVNode(_component_Multiselect, {
                      modelValue: $setup.filters.PatientName,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.filters.PatientName) = $event)),
                      options: $setup.patients,
                      placeholder: "Type to search",
                      searchable: true,
                      "close-on-select": true,
                      label: "FullName",
                      "track-by": "ID"
                    }, null, 8, ["modelValue", "options"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _hoisted_17,
                  _createElementVNode("div", _hoisted_18, [
                    _withDirectives(_createElementVNode("input", {
                      type: "date",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.filters.ServiceDate.StartDate) = $event)),
                      class: "form-control w-50",
                      required: ""
                    }, null, 512), [
                      [_vModelText, $setup.filters.ServiceDate.StartDate]
                    ]),
                    _hoisted_19,
                    _withDirectives(_createElementVNode("input", {
                      type: "date",
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.filters.ServiceDate.EndDate) = $event)),
                      class: "form-control w-50",
                      required: ""
                    }, null, 512), [
                      [_vModelText, $setup.filters.ServiceDate.EndDate]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _hoisted_21,
                  _createElementVNode("div", _hoisted_22, [
                    _withDirectives(_createElementVNode("input", {
                      type: "date",
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.filters.SubmissionDate.StartDate) = $event)),
                      class: "form-control w-50",
                      required: ""
                    }, null, 512), [
                      [_vModelText, $setup.filters.SubmissionDate.StartDate]
                    ]),
                    _hoisted_23,
                    _withDirectives(_createElementVNode("input", {
                      type: "date",
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.filters.SubmissionDate.EndDate) = $event)),
                      class: "form-control w-50",
                      required: ""
                    }, null, 512), [
                      [_vModelText, $setup.filters.SubmissionDate.EndDate]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_24, [
                  _hoisted_25,
                  _createElementVNode("div", _hoisted_26, [
                    _createVNode(_component_Multiselect, {
                      modelValue: $setup.filters.ClaimStatus,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.filters.ClaimStatus) = $event)),
                      options: $setup.statuses,
                      placeholder: "Type to search",
                      searchable: true,
                      "close-on-select": true,
                      openDirection: "bottom"
                    }, null, 8, ["modelValue", "options"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_27, [
                  _createVNode(_component_router_link, {
                    class: "btn btn-secondary",
                    to: { name: 'participant.claims' }
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Back")
                    ]),
                    _: 1
                  }, 8, ["to"]),
                  _createElementVNode("button", {
                    class: "btn btn-primary w-25",
                    onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => ($setup.searchData && $setup.searchData(...args)))
                  }, _toDisplayString($setup.loadingSearch ? 'Searching...' : 'Search'), 1)
                ])
              ]))
            : (!$setup.loadingSearch && $setup.claimsHistory?.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                  _createElementVNode("button", {
                    class: "btn btn-secondary col-md-2 mb-4",
                    onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => ($setup.resetFilters && $setup.resetFilters(...args)))
                  }, " Change my current Filters "),
                  _createElementVNode("table", _hoisted_29, [
                    _hoisted_30,
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.claimsHistory, (entry, index) => {
                        return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                          _createElementVNode("tr", _hoisted_31, [
                            _createElementVNode("td", null, [
                              _createElementVNode("button", {
                                class: "btn btn-sm btn-secondary",
                                onClick: ($event: any) => ($setup.toggleDetails(index))
                              }, _toDisplayString(entry.showDetails ? ' - ' : ' + '), 9, _hoisted_32)
                            ]),
                            (entry.Claim?.ClaimID)
                              ? (_openBlock(), _createElementBlock("td", _hoisted_33, [
                                  _createVNode(_component_router_link, {
                                    to: { name: 'participant.claims.new', params: { ClaimID: entry.Claim?.ClaimID, Type: entry.Type } }
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(entry.Claim?.ClaimID), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["to"])
                                ]))
                              : (_openBlock(), _createElementBlock("td", _hoisted_34, _toDisplayString(entry.Claim?.ClaimID), 1)),
                            (!entry.Claim?.ClaimID)
                              ? (_openBlock(), _createElementBlock("td", _hoisted_35, [
                                  _createVNode(_component_router_link, {
                                    to: { name: 'participant.claims.new', params: { ClaimID: entry.Claim?.NEICID, Type: entry.Type } }
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(entry.Claim?.NEICID), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["to"])
                                ]))
                              : (_openBlock(), _createElementBlock("td", _hoisted_36, _toDisplayString(entry.Claim?.NEICID), 1)),
                            _createElementVNode("td", null, _toDisplayString(entry.Claim?.DatesOfService), 1),
                            _createElementVNode("td", null, _toDisplayString(entry.Claim?.Name), 1),
                            _createElementVNode("td", null, _toDisplayString(entry.Claim?.DoB), 1),
                            _createElementVNode("td", null, _toDisplayString(entry.Claim?.Relationship), 1),
                            _createElementVNode("td", null, _toDisplayString(entry.Claim?.ClaimStatus), 1),
                            _createElementVNode("td", null, _toDisplayString(entry.Claim?.ClaimDocs), 1),
                            _createElementVNode("td", null, _toDisplayString(entry.Claim?.EOBDocs), 1)
                          ]),
                          (entry.showDetails)
                            ? (_openBlock(), _createElementBlock("tr", {
                                key: 'details-' + index
                              }, [
                                _createElementVNode("td", _hoisted_37, [
                                  _createElementVNode("table", _hoisted_38, [
                                    _hoisted_39,
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(entry.Details, (detail, detailIndex) => {
                                      return (_openBlock(), _createElementBlock("tr", {
                                        key: detailIndex,
                                        class: "text-center align-middle"
                                      }, [
                                        _createElementVNode("td", null, _toDisplayString(detail.AmtRequested), 1),
                                        _createElementVNode("td", null, _toDisplayString(detail.OtherCarrier), 1),
                                        _createElementVNode("td", null, _toDisplayString(detail.AdminFee), 1),
                                        _createElementVNode("td", null, _toDisplayString(detail.AmtPaid), 1),
                                        _createElementVNode("td", null, _toDisplayString(detail.DateReceived), 1),
                                        _createElementVNode("td", null, _toDisplayString(detail.PaymentInfo), 1),
                                        _createElementVNode("td", null, _toDisplayString(detail.CheckDepositDate), 1),
                                        _createElementVNode("td", null, _toDisplayString(detail.PreviousClaim), 1),
                                        _createElementVNode("td", null, _toDisplayString(detail.Notes), 1)
                                      ]))
                                    }), 128))
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ], 64))
                      }), 128))
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
      ])
    ])
  ]))
}